/* eslint-disable no-undef */
import { utilities } from '@weatherbug/common';
const { PulseApi } = utilities;

const  _getLocationBySearchStringPath = '/data/locations/v3/location';
const _getLocationDetailsByCityIdUri = '/data/locations/v1/CityByCityId';
const _hourlyForecastUri = '/data/forecasts/v2/hourly';
const _currentStationObsUri = '/data/observations/v4/current';
const _getcontentManagementUri = '/api/content/resources/location';

export class WeatherWidgetsProvider {
    constructor(baseUrl: string, authid: string, secret: string, options = { timeout: 5000 }) {
        this.options = options;

        this.pulseApi = new PulseApi(
            authid,
            secret,
            baseUrl,
            this.options.timeout
        );
    }

    async getLocationDetailsFromPostalCode(
        postalCode: string,
        maxResults: number,
        verbose: boolean
    ): Promise<any>  {
        try {
            const queryParams = {
                searchString: postalCode, 
                maxResults,
                verbose
            };
            
            const result = await this.pulseApi.getData(_getLocationBySearchStringPath, queryParams, 5000, 'json', true);
            return result?.[0];
    
        } catch (error) {
            console.log('Failed to get location details by postal code', error);
        }
    }

    async getLocationDetailsFromCityId(
        cityId: string
    ): Promise<any>  {
        try {
            const queryParams = {
                cityId
            };
            
            const result = await this.pulseApi.getData(_getLocationDetailsByCityIdUri, queryParams, 5000, 'json', true);
            return result;
    
        } catch (error) {
            console.log('Failed to get location details by widget city id', error);
        }
    }

    async getWidgetStationObs(
        location: string, 
        locationtype: string, 
        offset: number, 
        units: string, 
        verbose?: boolean, 
        refresh?: boolean
    ): Promise<any> {
        try {
            const queryParams = {
                location,
                locationtype,
                offset,
                units,
                verbose,
                refresh
            };

            const result = await this.pulseApi.getData(_currentStationObsUri, queryParams, 5000, 'json', true);
            return result;
    
        } catch (error) {
            console.log('Failed to get stations obs details from station id', error);
        }
    }

    async getWidgetHourlyForecast(
        location: string, 
        locationtype: string, 
        offset: number, 
        units: string, 
        verbose?: boolean, 
        refresh?: boolean
    ): Promise<any> {
        try {
            const queryParams = {
                location,
                locationtype,
                offset,
                units,
                verbose,
                refresh
            };

            const result = await this.pulseApi.getData(_hourlyForecastUri, queryParams, 5000, 'json', true);
            return result?.hfp?.[0];
    
        } catch (error) {
            console.log('Failed to get hourly forecast', error);
        }
    }

    async getWidgetForecastIcon(
        resourceList: string,
        stdParameters = {}
    ): Promise<any> {
        try {
            const queryParams = {
                ...stdParameters,
                resourcelist: resourceList,
                verbose: true
            };

            const result = await this.pulseApi.getData(_getcontentManagementUri, queryParams, 5000, 'json', true);
            return result;
    
        } catch (error) {
            console.log('Failed to get widget forecast Icon', error);
        }
    }
}